import { Modal, Spinner } from "react-bootstrap";
// import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCart } from "features/common/layouts/cartSlice";
import { useState } from "react";

const ModalConfirmationCancel = (props) => {
  // const location = useLocation();
  const dispatch = useDispatch();
  const [redirecting, setRedirecting] = useState(false);

  const handlerCancel = () => {
    dispatch(clearCart());
    setRedirecting(true);
    let url = "";
    // console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV === "production") {
      url = "https://qwords.com/";
    }
    if (process.env.NODE_ENV === "development") {
      url = "https://staging.qwords.com/";
    }
    setTimeout(() => {
      props.onHide();
      window.location.href = url;
    }, 1000);
  };

  return (
    <>
      <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
        <Modal.Header closeButton>
          <Modal.Title>Lihat Produk Lain</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {redirecting ? (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 120 }}>
              <Spinner animation="border" role="status" className="mb-3" />
              <div className="fw-bold" style={{ fontSize: 18 }}>Redirecting...</div>
              <div className="text-muted mt-2" style={{ fontSize: 14 }}>Anda akan diarahkan ke halaman utama dalam beberapa detik.</div>
            </div>
          ) : (
            <>
              <div>
                <p style={{ fontSize: "18px" }}>
                  Apakah anda ingin membersihkan keranjang belanja dan melihat produk lain?
                </p>
              </div>
              <div className="row mt-5">
                <div className="col-lg-6 col-12">
                  <button
                    className="btn btn-modal-outline-daftar-secondary w-100"
                    onClick={props.onHide}
                  >
                    Kembali
                  </button>
                </div>
                <div className="col-lg-6 col-12">
                  <button
                    className="btn btn-modal-confirmation w-100"
                    onClick={handlerCancel}
                  >
                    Setuju
                  </button>
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalConfirmationCancel;
